import { render, staticRenderFns } from "./driverslist.vue?vue&type=template&id=04ecd21a&scoped=true"
import script from "./driverslist.js?vue&type=script&lang=js&external"
export * from "./driverslist.js?vue&type=script&lang=js&external"
import style0 from "./driverslist.vue?vue&type=style&index=0&id=04ecd21a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ecd21a",
  null
  
)

export default component.exports